import React from 'react';
import { Box, Typography, ButtonBase } from '@mui/material';

const IOSSegmentedControl = ({
  options = [
    { label: 'YES', value: 'YES' },
    { label: 'NO', value: 'NO' }
  ],
  value,
  onChange,
  disabled = false,
  fullWidth = true,
  size = 'medium',
  error = false,
  sx = {}
}) => {
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        width: fullWidth ? '100%' : 'auto',
        bgcolor: error ? '#FEF2F2' : '#F1F5F9',
        p: '4px',
        borderRadius: '12px',
        border: error ? '1.5px solid #EF4444' : '1px solid #E2E8F0',
        opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        transition: 'all 0.2s ease',
        minHeight: '44px',
        ...sx
      }}
    >
      {options.map((opt) => {
        const isSelected = String(value) === String(opt.value);
        return (
          <ButtonBase
            key={opt.value}
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            sx={{
              flex: 1,
              py: size === 'small' ? 0.75 : 1,
              px: 2,
              borderRadius: '9px',
              fontWeight: 700,
              fontSize: size === 'small' ? '13px' : '14px',
              color: isSelected ? '#059669' : '#64748B',
              bgcolor: isSelected ? '#FFFFFF' : 'transparent',
              boxShadow: isSelected ? '0 2px 8px rgba(0, 0, 0, 0.08)' : 'none',
              transition: 'all 0.22s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                bgcolor: isSelected ? '#FFFFFF' : 'rgba(255, 255, 255, 0.5)',
              }
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: isSelected ? 700 : 600,
                fontSize: 'inherit',
                color: 'inherit'
              }}
            >
              {opt.label}
            </Typography>
          </ButtonBase>
        );
      })}
    </Box>
  );
};

export default IOSSegmentedControl;
